import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getUser = async () => {
  return await apiClient.get(ENDPOINTS.USERS);
};
